import React, { createContext, useContext, useMemo, useState } from "react";

export type LetterBoxStatus = "not_deleted" | "deleted" | "favourite";

export type LetterBoxFilters = {
  status: LetterBoxStatus;
  selectNumber?: number;
  search?: string;
  new?: 1;
};

type Ctx = {
  filters: LetterBoxFilters;
  setStatus: (status: LetterBoxStatus) => void;
  setSelectNumber: (value?: number) => void;
  setSearch: (value?: string) => void;
  setUnreadOnly: (enabled: boolean) => void;
};

const LetterBoxFilterContext = createContext<Ctx | null>(null);

export function LetterBoxFilterProvider({ children }: { children: React.ReactNode }) {
  const [filters, setFilters] = useState<LetterBoxFilters>({ status: "not_deleted" });

  const setStatus = (status: LetterBoxStatus) =>
    setFilters((prev) => ({ ...prev, status }));
  const setSelectNumber = (selectNumber?: number) =>
    setFilters((prev) => ({ ...prev, selectNumber }));
  const setSearch = (search?: string) =>
    setFilters((prev) => ({ ...prev, search }));

  const setUnreadOnly = (enabled: boolean) =>
    setFilters(prev => ({ ...prev, new: enabled ? 1 : undefined, selectNumber: undefined }));

  const value = useMemo(() => ({ filters, setStatus, setSelectNumber, setSearch, setUnreadOnly }), [filters]);
  return <LetterBoxFilterContext.Provider value={value}>{children}</LetterBoxFilterContext.Provider>;
}

export function useLetterBoxFilter() {
  const ctx = useContext(LetterBoxFilterContext);
  if (!ctx) throw new Error("useLetterBoxFilter must be used within LetterBoxFilterProvider");
  return ctx;
}
